module.exports = __webpack_public_path__ + "img/logo-cbgr.598c084a.png";